import { useEffect } from "react";
import { bootstrapSalesforce, clearSalesforce } from "../utils/SalesforceEmbeddedMessaging";
console.log("Salesforce module loaded");
const Salesforce = (props) => {
    const { orgId, embeddedMessagingName, baseUrl, scrt2Url, language, username } = props;
    console.log("Salesforce props", {
        orgId,
        embeddedMessagingName,
        baseUrl,
        scrt2Url,
        language,
        username
    });
    useEffect(() => {
        if (orgId && embeddedMessagingName && baseUrl && scrt2Url) {
            bootstrapSalesforce(orgId, embeddedMessagingName, baseUrl, scrt2Url, language ?? "en_US", username);
        }
        return () => {
            clearSalesforce();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return props.children || null;
};
Salesforce.displayName = "Salesforce";
export default Salesforce;
//# sourceMappingURL=Salesforce.js.map